import { common, header, footer } from './common';
import { auth, account, profilePicture, activity } from './auth';
import { appearance } from './appearance';
import { admin } from './admin';
import {
  website, suggestWebsite, addWebsite, editWebsite,
  manageWebsites, websiteSuggest, websiteManagement
} from './website';
import { home, categories, statistics, websiteDetails } from './pages';
import { legalNotice, privacy, terms, help } from './legal';
import { errors, errorPage } from './errors';

export const de = {
  common,
  header,
  footer,
  auth,
  account,
  appearance,
  profilePicture,
  activity,
  admin,
  website,
  suggestWebsite,
  addWebsite,
  editWebsite,
  manageWebsites,
  websiteSuggest,
  websiteManagement,
  home,
  categories,
  statistics,
  websiteDetails,
  legalNotice,
  privacy,
  terms,
  help,
  errors,
  errorPage,
};
